module.exports = __webpack_public_path__ + "static/media/nutty_tobacco.b4071d89.png";